import React, {useEffect } from 'react'; 
import { Link } from 'react-router-dom'
import Header from "../Component/Header";
const SchoolTransportUKGtoXII = () => {
    useEffect(() => {
        document.title = 'School Transport UKG-XII -  The Air Force School Subroto Park';  
    }, []);  
  return (
     <>
       <Header/>
<div className="innerslide">
            <ul className="breadcrumb">
                <li><Link to="/"> Home</Link> </li> 
                <li>  Facilities</li>
                <li>School Transport</li> 
                 <li>School Transport UKG-XII </li>
            </ul>
        </div> 
        <div className="innersec">
            <div className="container">
                <div className="row">
                    <div className="col-lg-12">
                        <h1> School Transport UKG-XII  </h1>
                    </div>
                </div>
                <div className="row">
                <div className="col-lg-6">
                            <div className="linktab"> <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/School Transport dated.pdf" target="_blank">   Click here to view the circular </Link> </div>
                    </div>
                    <div className="col-lg-6">
                            <div className="linktab">  <Link to="https://webapi.entab.info/api/image/TAFS/public/pdf/Route-wise.pdf" target="_blank"> Click here to view the Route-wise : List of students </Link> </div>
                    </div>
                </div>
            </div>
        </div>
     </>
  )
}

export default SchoolTransportUKGtoXII